import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Literal from 'components/literal';
import { ButtonPrimary, ButtonModalSecondary } from 'components/buttons';
import { Close } from 'components/SvgIcons';
import { CFM_STONE } from 'constants/Colors';
import './styles.scss';

/**
 * General component description.
 */

class FormModal extends React.Component {
    constructor(props) {
        super(props);

        this.rootSelector = document.getElementById('modal-root');
        this.el = document.createElement('div');

        this.contentRef = React.createRef();
    }

    componentDidMount() {
        this.rootSelector.appendChild(this.el);
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        this.rootSelector.removeChild(this.el);
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside = (event) => {
        const { isOpen, closeModal = () => null } = this.props;
        if (isOpen && !this.contentRef.current.contains(event.target)) {
            closeModal(event);
        }
    };

    renderChildren() {
        const {
            btnDisabled,
            closeModal = () => null,
            isOpen,
            children,
            onCancel = () => null,
            onSuccess = () => null,
            title = '',
        } = this.props;
        const className = `form-modal ${isOpen ? 'show' : ''}`;
        return (
            <Fragment>
                {isOpen && <div className="modal-overlay" />}
                <div className={className} ref={this.contentRef}>
                    <div className="form-modal-inside">
                        <div className="form-modal-header">
                            <span className="form-modal-header__text">
                                <Literal literal={title} />
                            </span>
                            <div
                                role="button"
                                tabIndex="-1"
                                className="form-modal-header__close-btn"
                                onClick={closeModal}
                                data-test="form-modal-close"
                            >
                                <Close color={CFM_STONE} />
                            </div>
                        </div>
                        <div className="form-modal-content">{children}</div>
                        <div className="form-modal-footer">
                            <ButtonModalSecondary onClick={onCancel} dataTest="form-modal-cancel">
                                <Literal literal="cfm_action_close" />
                            </ButtonModalSecondary>
                            <ButtonPrimary
                                onClick={onSuccess}
                                disabled={btnDisabled}
                                dataTest="form-modal-success"
                            >
                                <Literal literal="cfm_action_preview_changes" />
                            </ButtonPrimary>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }

    render() {
        return ReactDOM.createPortal(this.renderChildren(), this.el);
    }
}

FormModal.propTypes = {
    /** Description of prop "children". */
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    /** Indicate if modal is opened */
    isOpen: PropTypes.bool,
    /** Function to call when close modal */
    closeModal: PropTypes.func,
    btnDisabled: PropTypes.bool,
    onCancel: PropTypes.func,
    onSuccess: PropTypes.func,
    title: PropTypes.string,
};

export default FormModal;
